import { BaseService } from "@/core/services/BaseService";

class TimelineService extends BaseService<any> {
  endpoint = "/timeline"
}

export default new TimelineService()